











import Vue from 'vue'
import FileList from './FileList.vue'
import FileDetail from './FileDetail.vue'
import mixin from '../../../../components/FileTable/mixin.vue'

export default Vue.extend({
  name: 'TurnAroundDoc',
  mixins: [mixin],
  components: { FileList, FileDetail },
  props: {
    tableData: {
      type: Array,
      default: () => ([])
    },
    transferId: { // 工位文件的id
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dataSource: []
    }
  },
  watch: {
    transferId: {
      handler() {
        this.dataSource = []
      },
      immediate: true
    },
    tableData: {
      handler(val) {
        this.dataSource = val
      },
      immediate: true
    }
  },
  methods: {
    handleDelete(data: any) {
      this.$emit('handleDel', data)
    }
  }
})
